<template>
	<ui-modal-info
		:name="name"
		:title="user.customer_name"
		:sub-title="subTitle"
		icon="fal fa-user"
		color-circle="#24D798"
		icon-circle
		:body-loading="loader.body"
	>
		<template #top-modal>
			<ui-tag-indicator :color="user.idle_color" :text="user.id" text-size="11" :radius="20" />
		</template>

		<div class="lead-origin" v-if="!!user.product_name">{{ user.product_name }}</div>

		<div v-if="!!user.customer_phone || !!user.customer_mobile" class="user-phones">
			<ui-tag-indicator
				v-if="!!user.customer_phone"
				color="#F99E8F"
				:text="formatPhoneNew(user.customer_country_code_phone, user.customer_phone)"
				text-size="14"
				:radius="20"
				icon="fal fa-phone inv"
			/>

			<ui-tag-indicator
				v-if="!!user.customer_mobile"
				color="#24D798"
				:text="formatPhoneNew(user.customer_country_code_mobile, user.customer_mobile)"
				text-size="14"
				:radius="20"
				icon="fab fa-whatsapp"
			/>
		</div>

		<div v-if="!!user.customer_email" class="user-email">
			<strong>Email:</strong> {{ user.customer_email }}
		</div>

		<template #after-footer>
			<div class="actions-footer-after">
				<div class="title-footer">Deseja executar uma ação?</div>
				<div class="select-actions">
					<ui-select-2
						v-model="actual_action"
						placeholder="Selecionar Ação"
						:show-footer="false"
						:search="false"
						:data="actions"
						item-label="label"
						return-value="action"
						@input="handlerAction"
					/>
				</div>
			</div>
		</template>
	</ui-modal-info>
</template>

<script>
	import { uiTagIndicator } from '@/components/ui/tags'
	import { uiModalInfo } from '@/components/ui/modal/'
	import { uiSelect2 } from '@/components/ui/form'
	import { phoneMask } from '@/filters'
	import { maskIntl } from '@/mixins'

	import { defaultLoader, defaultUser, defaultActions } from './default'

	export default {
		name: 'ui-user-info-modal',

		components: {
			uiModalInfo,
			uiTagIndicator,
			uiSelect2,
		},

		mixins: [maskIntl],

		props: {
			name: {
				type: String,
				required: true,
			},
		},

		filters: {
			phoneMask,
		},

		data() {
			return {
				user: { ...defaultUser() },
				loader: { ...defaultLoader() },
				actions: [...defaultActions()],
				actual_action: null,
			}
		},

		created() {
			this.$root.$on('modal-open-' + this.name, async (payload) => {
				this.actual_action = null
				this.user = { ...payload }
 
				/**
				* Caso não receba o valor de customer_country_code, ira assumir o DDI brasileiro '55'
				* Necessário enquanto todos os números do banco de dados ainda não possuem DDI
				*/
				if(this.user.customer_mobile){
					this.user.customer_country_code_mobile = this.user.customer_country_code_mobile ? this.user.customer_country_code_mobile : 55
				}
				if(this.user.customer_phone){
					this.user.customer_country_code_phone = this.user.customer_country_code_phone ? this.user.customer_country_code_phone : 55
				}
			})
		},

		computed: {
			subTitle() {
				return this.user.customer_cpf ? `CPF: ${this.user.customer_cpf}` : ''
			},
		},

		methods: {
			handlerAction(action) {
				this.$root.$emit(action, this.user)
				this.actual_action = null

				const item = this.actions.find(a => a.action == action)
				if(item.gtm) this.$gtm.trackEvent(item.gtm)
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
